module.exports = "<p>Logging Out</p>\n"